{
  "sdk-download-android": "Pobierz na Androida",
  "sdk-connect": "Połącz",
  "sdk-download-ios": "Pobierz na iOS",
  "sdk-install": "Zainstaluj",
  "sdk-modal-instruct-1": "1. Otwórz Aplikację Binance",
  "sdk-modal-instruct-2": "2. Kliknij {{icon}} na ekranie głównym",
  "sdk-modal-title": "Połącz z Binance",
  "sdk-no-app": "Nie masz jeszcze aplikacji Binance?"
}